const variables = [
    'fgColor',
    'fgColorAlt',
    'bgColor',
    'bgColorAlt',
    'accentColor',
    'siteWidth',
    'sitePadding',
    'sectionMargin',
    'headerHeight',
];
function cssVar(name) {
    return `var(--${name})`;
}
function setCssVar(name, value) {
    return `--${name}: ${value}`;
}
export { cssVar, setCssVar };
